export default __webpack_public_path__ + "static/media/HELLO.82779df9.gif";